<h2 class="comreg-accent">New Account Registration</h2>
@if (!submitted) {
  <mat-stepper linear #stepper [animationDuration]="0">
    <ng-template matStepperIcon="edit">
      <mat-icon>check</mat-icon>
    </ng-template>
    <mat-step [editable]="isEditable" [stepControl]="formGroupAccountType">
      <ng-template matStepLabel>Account Type</ng-template>
      <acc-registration-account-type></acc-registration-account-type>
    </mat-step>
    @if (accountTypeSelected) {
      @if (showRadioTabs) {
        <mat-step [editable]="isEditable" [stepControl]="formGroupLicenceType">
          <ng-template matStepLabel>Licence Type</ng-template>
          <acc-registration-licence-type></acc-registration-licence-type>
        </mat-step>
      }
      <mat-step [editable]="isEditable" [stepControl]="formGeneralDetails">
        <ng-template matStepLabel>General Details</ng-template>
        <acc-registration-general-details></acc-registration-general-details>
      </mat-step>
      @if (showRadioTabs && isCompany) {
        <mat-step [editable]="isEditable" [stepControl]="formFinancialDetails">
          <ng-template matStepLabel>Financial Details</ng-template>
          <acc-registration-financial-details></acc-registration-financial-details>
        </mat-step>
        <mat-step [editable]="isEditable" [stepControl]="formRadioContactDetails">
          <ng-template matStepLabel>Contact</ng-template>
          <acc-registration-contact-details [formGroup]="formRadioContactDetails"></acc-registration-contact-details>
        </mat-step>
      }
      @if (showPrsTabs) {
        <mat-step [editable]="isEditable" [stepControl]="formPrsDetails">
          <ng-template matStepLabel>PRS Details</ng-template>
          <acc-registration-prs-details></acc-registration-prs-details>
        </mat-step>
        <mat-step [editable]="isEditable" [stepControl]="formPrsContact1Details">
          <ng-template matStepLabel>Contact 1</ng-template>
          <acc-registration-contact-details [contactNumber]="1"></acc-registration-contact-details>
        </mat-step>
        <mat-step [editable]="isEditable" [stepControl]="formPrsContact2Details">
          <ng-template matStepLabel>Contact 2</ng-template>
          <acc-registration-contact-details [contactNumber]="2" [showRegulatoryCheckBox]="true"></acc-registration-contact-details>
        </mat-step>
        @if (numberOfPrsContacts === 3) {
          <mat-step [editable]="isEditable" [stepControl]="formPrsContact3Details">
            <ng-template matStepLabel>Contact 3</ng-template>
            <acc-registration-contact-details [contactNumber]="3"></acc-registration-contact-details>
          </mat-step>
        }
      }
      <mat-step [editable]="isEditable">
        <ng-template matStepLabel>Confirmation</ng-template>
        <h2>Confirmation</h2>
        <div class="account-registration__container account-registration__container--with-wizard-buttons">
          <div class="account-registration__info">Everything is ready. Click on Submit Application button to send your registration data.</div>
        </div>
      </mat-step>
    }
  </mat-stepper>

  <com-wizard-buttons [stepper]="stepper" (action)="wizardButtonAction($event)" [options]="wizardButtonOptions"> </com-wizard-buttons>
} @else {
  <div class="account-registration__container account-registration__container--with-wizard-buttons">
    <div class="account-registration__info">
      Registration Successfully Requested
      <br />
      You will be contacted shortly by Comreg.
    </div>
  </div>
}
